import axios from 'axios';

const API_URL = process.env.API_URL;

export async function verify(token) {
  const url = `${API_URL}/dashboard/auth/verify`;
  return axios.post(url, { token }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function resendVerification(email) {
  const url = `${API_URL}/dashboard/auth/resend-email`;
  return axios.post(url, { email }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}



// WEBPACK FOOTER //
// ./src/services/email.js